import {SET_ACTIVE_TEST_TYPE} from "./availableActions";
import {SetActiveTestTypeAction} from "../../interfaces/store/test";

export const setActiveTestType = (payload: string): SetActiveTestTypeAction => ({
    type: SET_ACTIVE_TEST_TYPE,
    payload,
});
